export const i18nStyleguideEs = {
  error_fallback: {
    error_msg: '¡Oh no! Parece que algo salió mal. Por favor contacta a tu administrador.',
  },
};
